<div class="view-list-container">
    <ng-content></ng-content>
</div>